import { render, staticRenderFns } from "./AllAssessmentsTable.vue?vue&type=template&id=05289014&scoped=true&"
import script from "./AllAssessmentsTable.vue?vue&type=script&lang=js&"
export * from "./AllAssessmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05289014",
  null
  
)

/* custom blocks */
import block0 from "./AllAssessmentsTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
